var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 5.5C3.5 4.39543 4.39543 3.5 5.5 3.5H22.5C23.6046 3.5 24.5 4.39543 24.5 5.5V22.5C24.5 23.6046 23.6046 24.5 22.5 24.5H5.5C4.39543 24.5 3.5 23.6046 3.5 22.5V5.5ZM12 10C12 9.44772 12.4477 9 13 9H19C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11H13C12.4477 11 12 10.5523 12 10ZM9 11C9.55228 11 10 10.5523 10 10C10 9.44772 9.55228 9 9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11ZM12 14C12 13.4477 12.4477 13 13 13H19C19.5523 13 20 13.4477 20 14C20 14.5523 19.5523 15 19 15H13C12.4477 15 12 14.5523 12 14ZM9 15C9.55228 15 10 14.5523 10 14C10 13.4477 9.55228 13 9 13C8.44772 13 8 13.4477 8 14C8 14.5523 8.44772 15 9 15ZM12 18C12 17.4477 12.4477 17 13 17H19C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H13C12.4477 19 12 18.5523 12 18ZM9 19C9.55228 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17C8.44772 17 8 17.4477 8 18C8 18.5523 8.44772 19 9 19Z",
    fill: "#3374B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.287fab2f6e515cb51d2d5c3b5e304e2c.svg";
export { ForwardRef as ReactComponent };